import { Card } from 'antd';
import React from 'react';
import './Account.scss';
import LandingFooter from '../../components/LandingFooter/LandingFooter';
import LandingHeader from '../../components/LandingHeader/LandingHeader';
import helpdesk from '../../assets/helpdesk.png';
import businessman from '../../assets/businessman.svg';
import dollar from '../../assets/dollar.svg';
import { Link } from 'react-router-dom';

const { Meta } = Card;

const Account = () => {
  return (
    <div className='page-landing-wrapper'>
      <LandingHeader />
      <div className='account-wrapper'>
        <div className='account-img-holder account'>
          <div className='container'>
            <div className='account-title'>
              <h1>تسجيل الدخول</h1>
              <p>من فضلك اختار نوع الحساب المراد تسجيل الدخول اليه</p>
            </div>
          </div>
        </div>

        <div className='account-holder'>
          <Link to='/signin'>
            <Card>
              <Meta
                description={
                  <div className='account-content'>
                    <img src={businessman} />
                    <h3> عميل</h3>
                  </div>
                }
              />
            </Card>
          </Link>

          <a href='https://finance.osoolard.com'>
            <Card>
              <Meta
                description={
                  <div className='account-content'>
                    <img src={dollar} />
                    <h3 style={{ marginTop: '40px' }}>جهة التمويل</h3>
                  </div>
                }
              />
            </Card>
          </a>

          <a href='https://agancy.osoolard.com'>
            <Card>
              <Meta
                description={
                  <div className='account-content'>
                    <img src={helpdesk} />
                    <h3>الموظفين </h3>
                  </div>
                }
              />
            </Card>
          </a>
        </div>

        <div className='account-footer'>
          <h1>
            ليس لديك حساب؟ <span></span>
            <Link to='/signup'>إنشاء حساب جديد</Link>
          </h1>
        </div>

        <div className='account-background'></div>
      </div>
      <LandingFooter />
    </div>
  );
};

export default Account;
